const LogisticManagementMasterItemsNewCustomUnit = async () =>
    import('../../pages/inventory/items/New').then((module) => ({
        Component: module.LogisticManagementMasterItemsNew,
    }));
const LogisticManagementMasterItemsEditCustomUnit = async () =>
    import('../../pages/inventory/items/Edit').then((module) => ({
        Component: module.LogisticManagementMasterItemsEdit,
    }));
const LogisticManagementMasterItemsListCustomUnit = async () =>
    import('../../pages/inventory/items/List').then((module) => ({
        Component: module.LogisticManagementMasterItemsList,
    }));
const LogisticManagementMasterItemsViewCustomUnit = async () =>
    import('../../pages/inventory/items/View').then((module) => ({
        Component: module.LogisticManagementMasterItemsView,
    }));

const getMasterItemRoutes = () => {
    return [
        // Master items with Custom Unit
        {
            path: '/logistic-management/inventory/items/new',
            lazy: LogisticManagementMasterItemsNewCustomUnit,
        },
        {
            path: '/logistic-management/inventory/items/:masterItemId/edit',
            lazy: LogisticManagementMasterItemsEditCustomUnit,
        },
        {
            path: '/logistic-management/inventory/items/:masterItemId/',
            lazy: LogisticManagementMasterItemsViewCustomUnit,
        },
        {
            path: '/logistic-management/inventory/items/',
            lazy: LogisticManagementMasterItemsListCustomUnit,
        },
        {
            path: '/logistic-management/inventory/items/archived/',
            lazy: LogisticManagementMasterItemsListCustomUnit,
        },
        {
            path: '/logistic-management/inventory/items/unarchived/',
            lazy: LogisticManagementMasterItemsListCustomUnit,
        },
    ];
};

export { getMasterItemRoutes };
